// ========== single Event Page ==========

  const eventsSlider = new Swiper(".single-event .events-slider", {
    // allowTouchMove: false,
    // loop: true,
    speed: 1600,
    slidesPerView: 2.3,
    centeredSlides: true,
    slidesPerGroup: 1,
    spaceBetween: -1,
    // pagination: {
    //   el: ".events-slider .swiper-pagination",
    //   type: "bullets",
    //   clickable: true,
    // },

    scrollbar: {
      el: ".events-slider .swiper-scrollbar",
      // type: "bullets",
      // clickable: true,
      type: "progressbar",
      draggable: true,
      clickable: true,
    },
    breakpoints: {
      0: {
        slidesPerView: 1.25,
        touchAngle: 45,
        touchRatio: 1,
      },
      769: {
        slidesPerView: 2.1,
      },
      993: {
        slidesPerView: 2.3,
        touchAngle: 180,
        touchRatio: 2,
      },
    },

    keyboard: {
      enabled: true,
      onlyInViewport: false,
      pageUpDown: true,
    },
    mousewheel: {
      invert: false,
      sensitivity: 1,
      eventsTarget: ".events-page",
    },
    initialSlide: 0,
    on: {
      init: function (swiper) {
        let slideElements = document.querySelectorAll(".events-slider .swiper-slide");
        slideElements.forEach((element) => {
          element.addEventListener("click", () => {
            if (element.classList.contains("swiper-slide-prev")) {
              swiper.slidePrev();
            }
            if (element.classList.contains("swiper-slide-next")) {
              swiper.slideNext();
            }
          });
        });
      },
      resize: function (swiper) {
        let slideElements = document.querySelectorAll(".events-slider .swiper-slide");
        slideElements.forEach((element) => {
          element.addEventListener("click", () => {
            if (element.classList.contains("swiper-slide-prev")) {
              swiper.slidePrev();
            }
            if (element.classList.contains("swiper-slide-next")) {
              swiper.slideNext();
            }
          });
        });

        var vw = $(window).width();
        var vh = $(window).height();
        if (vw > 769 && vw > vh) {
          eventsSlider.params.slidesPerView = 2.1;
        }
        if (vw > 769 && vw < vh) {
          eventsSlider.params.slidesPerView = 1.25;
        }
        eventsSlider.update();
      },
    },
  });

